import { Button, Dropdown, Menu } from "antd";
import React from "react";
import useRequestFn from "utils/useRequestFn";
import { downloadGradeTeaching, exportGradeTeaching } from "service/score";

interface MenuExportProps {
    courseNo: string;
    courseSeq: string;
    text: string;
}

export function MenuExport({ courseNo, courseSeq, text }: MenuExportProps) {
    const [downloadGradeTeachingFn, state1] = useRequestFn(
        downloadGradeTeaching
    );

    const [exportGradeTeachingFn, state2] = useRequestFn(exportGradeTeaching);

    return (
        <Dropdown
            overlay={
                <Menu>
                    <Menu.Item>
                        <Button
                            type="link"
                            loading={state2.loading}
                            onClick={() =>
                                exportGradeTeachingFn(courseNo, courseSeq, text)
                            }>
                            导出综合教务成绩单（过程化）
                        </Button>
                    </Menu.Item>

                    <Menu.Item>
                        <Button
                            type="link"
                            loading={state1.loading}
                            onClick={() =>
                                downloadGradeTeachingFn(
                                    courseNo,
                                    courseSeq,
                                    text
                                )
                            }>
                            导出成绩单（非过程化）
                        </Button>
                    </Menu.Item>
                </Menu>
            }
            placement="bottomLeft">
            <Button type="primary" ghost>
                导出
            </Button>
        </Dropdown>
    );
}
